import { enabledFieldsPerReportMap } from '@features/filters/chipBasedFilters/constants';
import {
  CHIP_FILTERS_ENTITY,
  type CHIPS_ALLOWED_MODULE,
  type FiltersEntityWithoutType,
  type IFiltersInitialValues,
  OPERATOR_TYPE,
} from '@features/filters/types';

const {
  ID,
  CODE,
  TYPE,
  STATUS,
  CODE_ID,
  BRAND_ID,
  CATEGORY,
  GIVEN_AT,
  GIVEN_TO,
  OFFER_ID,
  CURRENCY,
  PLAYER_ID,
  ISSUED_BY,
  APPLIED_AT,
  APPLIED_TO,
  COUNTRY_ID,
  EXPIRES_AT,
  EXPIRES_TO,
  CAMPAIGN_ID,
  FILTER_TYPE,
  DECLINED_AT,
  DECLINED_TO,
  ACCEPTED_AT,
  ACCEPTED_TO,
  PAYOUT_TYPE,
  ACTIVATED_AT,
  ACTIVATED_TO,
  CANCELLED_AT,
  CANCELLED_BY,
  CANCELLED_TO,
  CONVERTED_AT,
  CONVERTED_TO,
  ISSUED_BY_ID,
  APPLIED_BY_ID,
  BET_REFERENCE,
  TRANSACTION_ID,
  ISSUING_METHOD,
  CANCELLED_BY_ID,
  GIVEN_AMOUNT_AT,
  GIVEN_AMOUNT_TO,
  BONUS_TEMPLATE_ID,
  CONVERTED_AMOUNT_AT,
  CONVERTED_AMOUNT_TO,
  PROFIT_BOOST_PERCENTAGE,
  GIVEN_AMOUNT_SYSTEM_CURRENCY_AT,
  GIVEN_AMOUNT_SYSTEM_CURRENCY_TO,
  CONVERTED_AMOUNT_SYSTEM_CURRENCY_AT,
  CONVERTED_AMOUNT_SYSTEM_CURRENCY_TO,
} = CHIP_FILTERS_ENTITY;

export const getChipBasedFiltersInitialValues = (
  module: CHIPS_ALLOWED_MODULE
) => {
  const initialValuesMap = {
    [FILTER_TYPE]: null,
    [TYPE]: {
      value: [],
      inversion: false,
      operator: OPERATOR_TYPE.IN,
    },
    [ID]: {
      value: '',
      inversion: false,
      operator: OPERATOR_TYPE.EQUAL,
    },
    [STATUS]: {
      value: [],
      inversion: false,
      operator: OPERATOR_TYPE.IN,
    },
    [CODE]: {
      value: '',
      inversion: false,
      operator: OPERATOR_TYPE.EQUAL,
    },
    [CATEGORY]: {
      value: [],
      inversion: false,
      operator: OPERATOR_TYPE.IN,
    },
    [BRAND_ID]: {
      value: [],
      inversion: false,
      operator: OPERATOR_TYPE.IN,
    },
    [CURRENCY]: {
      value: [],
      inversion: false,
      operator: OPERATOR_TYPE.IN,
    },
    [COUNTRY_ID]: {
      value: [],
      inversion: false,
      operator: OPERATOR_TYPE.IN,
    },
    [CODE_ID]: {
      value: '',
      inversion: false,
      operator: OPERATOR_TYPE.EQUAL,
    },
    [CAMPAIGN_ID]: {
      value: [],
      inversion: false,
      operator: OPERATOR_TYPE.IN,
    },
    [OFFER_ID]: {
      value: '',
      inversion: false,
      operator: OPERATOR_TYPE.EQUAL,
    },
    [PAYOUT_TYPE]: {
      value: [],
      inversion: false,
      operator: OPERATOR_TYPE.IN,
    },
    [ISSUED_BY]: {
      value: '',
      inversion: false,
      operator: OPERATOR_TYPE.LIKE,
    },
    [PLAYER_ID]: {
      value: '',
      inversion: false,
      operator: OPERATOR_TYPE.EQUAL,
    },
    [ISSUED_BY_ID]: {
      value: [],
      inversion: false,
      operator: OPERATOR_TYPE.IN,
    },
    [APPLIED_BY_ID]: {
      value: [],
      inversion: false,
      operator: OPERATOR_TYPE.IN,
    },
    [ISSUING_METHOD]: {
      value: [],
      inversion: false,
      operator: OPERATOR_TYPE.IN,
    },
    [CANCELLED_BY]: {
      value: '',
      inversion: false,
      operator: OPERATOR_TYPE.LIKE,
    },
    [CANCELLED_BY_ID]: {
      value: [],
      inversion: false,
      operator: OPERATOR_TYPE.IN,
    },
    [BET_REFERENCE]: {
      value: '',
      inversion: false,
      operator: OPERATOR_TYPE.EQUAL,
    },
    [TRANSACTION_ID]: {
      value: '',
      inversion: false,
      operator: OPERATOR_TYPE.EQUAL,
    },
    [BONUS_TEMPLATE_ID]: {
      value: [],
      inversion: false,
      operator: OPERATOR_TYPE.IN,
    },
    [GIVEN_TO]: {
      value: null,
      inversion: false,
      operator: OPERATOR_TYPE.LESS_THAN_OR_EQUAL,
    },
    [PROFIT_BOOST_PERCENTAGE]: {
      value: '',
      inversion: false,
      operator: OPERATOR_TYPE.EQUAL,
    },
    [APPLIED_TO]: {
      value: null,
      inversion: false,
      operator: OPERATOR_TYPE.LESS_THAN_OR_EQUAL,
    },
    [EXPIRES_TO]: {
      value: null,
      inversion: false,
      operator: OPERATOR_TYPE.LESS_THAN_OR_EQUAL,
    },
    [GIVEN_AT]: {
      value: null,
      inversion: false,
      operator: OPERATOR_TYPE.GREATER_THAN_OR_EQUAL,
    },
    [DECLINED_TO]: {
      value: null,
      inversion: false,
      operator: OPERATOR_TYPE.LESS_THAN_OR_EQUAL,
    },
    [ACCEPTED_TO]: {
      value: null,
      inversion: false,
      operator: OPERATOR_TYPE.LESS_THAN_OR_EQUAL,
    },
    [CANCELLED_TO]: {
      value: null,
      inversion: false,
      operator: OPERATOR_TYPE.LESS_THAN_OR_EQUAL,
    },
    [ACTIVATED_TO]: {
      value: null,
      inversion: false,
      operator: OPERATOR_TYPE.LESS_THAN_OR_EQUAL,
    },
    [CONVERTED_TO]: {
      value: null,
      inversion: false,
      operator: OPERATOR_TYPE.LESS_THAN_OR_EQUAL,
    },
    [APPLIED_AT]: {
      value: null,
      inversion: false,
      operator: OPERATOR_TYPE.GREATER_THAN_OR_EQUAL,
    },
    [EXPIRES_AT]: {
      value: null,
      inversion: false,
      operator: OPERATOR_TYPE.GREATER_THAN_OR_EQUAL,
    },
    [GIVEN_AMOUNT_TO]: {
      value: '',
      inversion: false,
      operator: OPERATOR_TYPE.LESS_THAN_OR_EQUAL,
    },
    [DECLINED_AT]: {
      value: null,
      inversion: false,
      operator: OPERATOR_TYPE.GREATER_THAN_OR_EQUAL,
    },
    [ACCEPTED_AT]: {
      value: null,
      inversion: false,
      operator: OPERATOR_TYPE.GREATER_THAN_OR_EQUAL,
    },
    [CANCELLED_AT]: {
      value: null,
      inversion: false,
      operator: OPERATOR_TYPE.GREATER_THAN_OR_EQUAL,
    },
    [ACTIVATED_AT]: {
      value: null,
      inversion: false,
      operator: OPERATOR_TYPE.GREATER_THAN_OR_EQUAL,
    },
    [CONVERTED_AT]: {
      value: null,
      inversion: false,
      operator: OPERATOR_TYPE.GREATER_THAN_OR_EQUAL,
    },
    [GIVEN_AMOUNT_AT]: {
      value: '',
      inversion: false,
      operator: OPERATOR_TYPE.GREATER_THAN_OR_EQUAL,
    },
    [CONVERTED_AMOUNT_TO]: {
      value: '',
      inversion: false,
      operator: OPERATOR_TYPE.LESS_THAN_OR_EQUAL,
    },
    [CONVERTED_AMOUNT_AT]: {
      value: '',
      inversion: false,
      operator: OPERATOR_TYPE.GREATER_THAN_OR_EQUAL,
    },
    [GIVEN_AMOUNT_SYSTEM_CURRENCY_TO]: {
      value: '',
      inversion: false,
      operator: OPERATOR_TYPE.LESS_THAN_OR_EQUAL,
    },
    [GIVEN_AMOUNT_SYSTEM_CURRENCY_AT]: {
      value: '',
      inversion: false,
      operator: OPERATOR_TYPE.GREATER_THAN_OR_EQUAL,
    },
    [CONVERTED_AMOUNT_SYSTEM_CURRENCY_TO]: {
      value: '',
      inversion: false,
      operator: OPERATOR_TYPE.LESS_THAN_OR_EQUAL,
    },
    [CONVERTED_AMOUNT_SYSTEM_CURRENCY_AT]: {
      value: '',
      inversion: false,
      operator: OPERATOR_TYPE.GREATER_THAN_OR_EQUAL,
    },
  };

  return Object.fromEntries(
    enabledFieldsPerReportMap[module].map((field) => [
      field,
      initialValuesMap[field as FiltersEntityWithoutType],
    ])
  ) as unknown as IFiltersInitialValues;
};
